import React from "react";
import { useSelector } from "react-redux";
import GoogleChart, { commonOptions } from "../../../../components/charts/googleChart/googleChart";
import NoData from "../../../../components/noData/noData";

const PieCharts = () => {
  const pieCharts = useSelector((state) => state.pastDuesPerformance.chartsData.pieCharts);
  if (!pieCharts) return null;

  if (pieCharts)
    return (
      <div className="section">
        {pieCharts.map(({ data_table: { cols, rows }, options }, index) => (
          <div key={index} className="section__el">
            {rows.length ? (
              <GoogleChart
                width={675}
                height={300}
                chartType="PieChart"
                columns={cols}
                rows={rows}
                options={{ ...commonOptions, ...options }}
                showCurrency={false}
                showAdditionTooltip={false}
                showXLSX={false}
              />
            ) : (
              <NoData />
            )}
          </div>
        ))}
      </div>
    );
};

export default PieCharts;
